/* tslint:disable */

/**
 * State of the delivery planning:
 *   * RECALCULATING
 *   * PLANNED_FOR_RECALCULATION
 *   * UP_TO_DATE
 */
type DeliveriesPlanningState =
  'RECALCULATING' |
  'PLANNED_FOR_RECALCULATION' |
  'UP_TO_DATE';
namespace DeliveriesPlanningState {
  export const RECALCULATING: DeliveriesPlanningState = 'RECALCULATING';
  export const PLANNED_FOR_RECALCULATION: DeliveriesPlanningState = 'PLANNED_FOR_RECALCULATION';
  export const UP_TO_DATE: DeliveriesPlanningState = 'UP_TO_DATE';
  export function values(): DeliveriesPlanningState[] {
    return [
      RECALCULATING,
      PLANNED_FOR_RECALCULATION,
      UP_TO_DATE
    ];
  }
}

export { DeliveriesPlanningState }